<template>
	<div class="p-6 space-y-3">
		<h1 class="text-2xl font-semibold text-gray-900 mb-6">
			{{ __("Referrals") }}
		</h1>
		<h2 class="font-semibold mb-4">WAS IST FREUNDE WERBEN FREUNDE?</h2>
		<p>
			Sie sind zufrieden mit cropspot? Dann laden Sie doch Ihre Freunde ein -
			und sichern sich ein attraktives Dankeschön. Auch ihre Freunde profitieren
			von Marktpreistransparenz, verbesserter Verhandlungsposition und
			erweitertem Aktionsradius.
		</p>
		<h2 class="font-semibold mb-4">IHR GESCHENK</h2>
		<p>
			Sichern Sie sich als cropspot Nutzer pro Neuregistrierung einen 25€
			Gutschein* und sparen Sie Kommission beim nächsten Kontrakt über cropspot.
		</p>
		<h2 class="font-semibold mb-4 uppercase">{{ __("Your referral link") }}</h2>
		<p>
			<small>{{ referralLink }}</small>
		</p>
		<button
			class="truncate bg-orange-500 text-white px-4 py-1.5 font-medium rounded-lg focus:ring-2 focus:ring-orange-200 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-orange-400 shadow hover:shadow-md hover:bg-orange-600 focus:outline-none font-medium"
			v-on:click="copyLink()"
		>
			{{ __("Copy link") }}
		</button>
		<p v-if="isCopied">Der Link wurde in die Zwischenablage kopiert.</p>

		<h2 class="font-semibold mb-4">FREUNDE WERBEN FREUNDE IN DREI SCHRITTEN</h2>
		<ol class="list-decimal list-inside">
			<li>
				Persönlichen Link kopieren – direkt z.B. über WhatsApp oder E-Mail
				beliebig oft teilen
			</li>
			<li>Freund*in registriert sich über den Empfehlungslink</li>
			<li>
				Pro Registrierung einen Gutschein erhalten und beim nächsten Kontrakt
				Kommission sparen
			</li>
		</ol>
		<p class="mt-8">
			<small
				>* Der 25-€-Gutschein gilt für einen Handel über cropspot und wird auf
				die Kommissionsgebühr angerechnet. Nicht mit anderen cropspot-Aktionen
				kombinierbar und nicht übertragbar. Das Angebot gilt für 12 Monate ab
				Registrierung der geworbenen Person. Die Voraussetzung für einen
				Prämienanspruch ist, dass der empfohlene "Neukunde" noch kein
				Kundenkonto bei cropspot GmbH besitzt und sich über den zugesandten
				Einladungslink registriert. Ein Prämienanspruch entsteht NICHT bei
				mündlicher oder telefonischer Empfehlung.
			</small>
		</p>
	</div>
</template>

<script>
import Button from "../Ui/Button.vue";
export default {
	components: { Button },
	props: {
		user: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			referralLink: `${window.location.origin}/register?referral_id=${this.user.referral_id}`,
			isCopied: false,
		};
	},
	methods: {
		copyLink() {
			navigator.clipboard.writeText(this.referralLink);
			this.isCopied = true;
		},
	},
};
</script>
<style scoped>
ol {
	list-style-type: decimal;
	margin: 13px;
}
</style>
